import React, { useEffect, useState } from "react";
import { SignalPulse } from "../components/SignalPulse";
import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { PostCard } from "./Feed";

export default function SinglePost() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [post, setPost] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let active = true;
    setPost(null);
    setError(false);
    api.get(`/posts/${id}`)
      .then(({ data }) => { if (active) setPost(data); })
      .catch(() => { if (active) setError(true); });
    return () => { active = false; };
  }, [id]);

  const handleDelete = async (postId) => {
    try {
      await api.delete(`/posts/${postId}`);
      navigate("/feed");
    } catch {
      alert("Could not delete the post. Please try again.");
    }
  };

  return (
    <div className="max-w-2xl mx-auto px-4 md:px-6 py-8" data-testid="single-post-page">
      <button onClick={() => navigate("/feed")} data-testid="single-post-back" className="flex items-center gap-2 text-zinc-400 hover:text-white font-body text-sm mb-8 transition-colors">
        <ArrowLeft size={16} /> Back to The Signal
      </button>

      {error ? (
        <div className="text-center py-20 border border-white/10" data-testid="single-post-missing">
          <p className="font-heading text-xl text-white mb-2">Signal not found</p>
          <p className="font-body text-sm text-zinc-500">This transmission may have been removed.</p>
        </div>
      ) : post === null ? (
        <div className="flex justify-center py-20"><SignalPulse size={44} /></div>
      ) : (
        <PostCard post={post} onNav={navigate} onDelete={handleDelete} currentUser={user} defaultOpenComments />
      )}
    </div>
  );
}
